import { Widget, useGlobalModalContext } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import styles from './CoreScoreWidget.module.scss';
import { CoreScoreWidgetProps } from '../../../models/Score';
import CoreScoreContent from './CoreScoreContent';
import { MODAL_TYPES } from '../../GlobalModal/GlobalModal';

const cx = classNames.bind(styles);

const CoreScoreWidget = (
  {
    scoreNumber,
    outlookNumber,
    riskFactor,
    nonRiskFactor,
    lastChanged,
    lastReviewed,
    isScore,
    noPrint,
    ...sortableWidgetProps
  }: CoreScoreWidgetProps,
  ref
): React.ReactElement => {
  const { showModal } = useGlobalModalContext();

  const onClick = () => {
    showModal(MODAL_TYPES.CORE_SCORE_VIEW);
  };

  return (
    <div className={cx('body', { 'no-print': noPrint })}>
      <Widget
        headerTitle="CoreScore"
        headerTooltip={{ tooltipText: 'More on CoreScore View', onClick }}
        ref={ref}
        {...sortableWidgetProps}
      >
        <CoreScoreContent
          isScore={isScore}
          scoreNumber={scoreNumber}
          outlookNumber={outlookNumber}
          riskFactor={riskFactor}
          nonRiskFactor={nonRiskFactor}
          lastChanged={lastChanged}
          lastReviewed={lastReviewed}
        />
      </Widget>
    </div>
  );
};

export default forwardRef(CoreScoreWidget);
